import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar";   // make sure you saved Navbar.js in /components
import Footer from "./Components/Footer";   // make sure you saved Footer.js in /components
import Home from "./Pages/Home";
import CategorySection from "./Pages/Category";
import ProductSectionNav from "./Pages/ProductNav";
import ContactUs from "./Pages/Contact";
import ProductInfoPage from "./Pages/ProductDetails";
import CartPage from "./Pages/Cart";
import CheckoutPage from "./Pages/Order";
import ProfilePage from "./Pages/Peofile";
import CategoryProductsPage from "./Pages/CategoryInfo";
import ScrollToTop from "./Components/Scroll";
import LoginPage from "./Pages/Login";
import SignUpPage from "./Pages/Register";
import MyOrders from "./Pages/MyOrders";
import About from "./Pages/About";




function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        {/* Navbar */}
        <Navbar />

        {/* Main Content */}
        <main className="flex-grow pt-16"> {/* pt-16 to avoid navbar overlap */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<ProductSectionNav />} />
            <Route path="/productInfo/:id" element={<ProductInfoPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/categories" element={<CategorySection />} />
            <Route path="/categories/:categoryId" element={<CategoryProductsPage />} />

            <Route path="/cart" element={<CartPage />} />
            <Route path="/order" element={<CheckoutPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/my-orders" element={<MyOrders />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignUpPage />} />

          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
